import { Deserializable } from '../../protocols/deserializable';
import { Country } from '../../types/dto/country';
import { State } from '../../types/dto/state';

export class Address implements Deserializable {
  public id!: string;
  public addressLine1!: string;
  public addressLine2!: string | null;
  public addressLine3!: string | null;
  public city!: string;
  public stateId!: number | null;
  public state!: State;
  public stateCode!: string;
  public countryId!: number;
  public country!: Country;
  public countryCode!: string;
  public postalCode!: string;
  public attention!: string | null;

  // Not from API
  countryName!: string;
  stateName!: string;

  onDeserialize(): void {
    if (!!this.state) {
      this.stateName = this.state.name;
      this.state = window.injector.Deserialize.instanceOf(State, this.state);
    }
    if (!!this.country) {
      this.countryName = this.country.name;
      this.country = window.injector.Deserialize.instanceOf(Country, this.country);
    }
  }
}
